import React, { useState, useEffect } from "react";
import metaimg from "../img/metaimg.png";
import twitter from "../img/twitter.png";
import logo from "../img/logo.png";
import PropagateLoader from "react-spinners/HashLoader";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { wait } from "@testing-library/user-event/dist/utils";
const Newprof = () => {
  const [nft, setNFTs] = useState(null);
  const [comm, setComm] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notok, setNotok] = useState(false);
  const [user, setUser] = useState(null);
  const [isnLoading, setIsnLoading] = useState(true);
  const navigate = useNavigate();
  const css = `display: block;`;
  const style = {
    position: "relative",
    top: "70px",
    left: "100%",
    transform: "translate(-50%, -50%)",
  };
  const override = `
  display: block;
  margin: 0 auto;
  border-color: red;
  `;
  const style1 = {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "fixed",
  };
  const getAccounts = async () => {
    await wait(3000).then(console.log(auth));
  };
  useEffect(() => {
    getAccounts().then(() => {
      const docRef = doc(db, "users", auth.currentUser.uid);
      getDoc(docRef).then((user) => {
        if (user.exists()) {
          if (user.data().tweetHandle != null && user.data().displayName) {
            setUser(user.data());
            setIsnLoading(false);
          }
        } else {
          setIsnLoading(false);
        }
      });
    });

    getNFT().then((cnt) => {
      if (cnt === 0) {
        setNotok(true);
      }
      setIsLoading(false);
    });
  }, []);
  const getNFT = async () => {
    let nfts;
    const api_key = "hqgLvhxNxeZkyFyZ8AExHl1PcQTQ6BlH";
    const baseURL = `https://eth-mainnet.alchemyapi.io/v2/${api_key}/getNFTs/`;
    var requestOptions = {
      method: "GET",
    };

    const fetchURL = `${baseURL}?owner=0xC1BB39bA8aB14b37d4dD59C457042F639dfef95d`;

    nfts = await fetch(fetchURL, requestOptions).then((data) => data.json());
    if (nfts) {
      let nnft = nfts.ownedNfts;
      let addr = new Set();
      let commlist = [];
      for (let i = 0; i < nnft.length; i++) {
        addr.add(nnft[i].contract.address);
      }
      for (let element of addr) {
        const baseURL = `https://eth-mainnet.alchemyapi.io/v2/${api_key}/getContractMetadata/`;
        var requestOptions = {
          method: "GET",
        };
        const fetchURL = `${baseURL}?contractAddress=${element}`;
        let res = await fetch(fetchURL, requestOptions).then((data) =>
          data.json()
        );
        let dict = {
          name: res.contractMetadata.openSea.collectionName,
          logo: res.contractMetadata.openSea.imageUrl,
        };
        commlist.push(dict);
      }
      console.log(commlist.length);
      setComm(commlist);
      setNFTs(nnft);
    }
    return nfts.ownedNfts.length;
  };
  const logout = async () => {
    signOut(auth);
    navigate(`/${user.displayName}`);
  };
  const twiit = () => {
    const text = encodeURIComponent(`GM everyone @doxdomxyz.`);
    return `https://twitter.com/intent/tweet?text=${text}`;
  };
  return (
    <div className="fprofile">
      {isnLoading && (
        <PropagateLoader
          color={"#4d00ac"}
          isLoading={isLoading}
          css={override}
          size={60}
          style={style1}
        />
      )}
      {!isnLoading && (
        <div className="nprofile">
          <div className="first">
            <div className="imgs">
              <img src={logo}></img>
            </div>
            <div className="btns">
              <div className="meta">
                <img src={metaimg}></img>
                <span>{user.uid.slice(0, 7) + "..." + user.uid.slice(-5)}</span>
              </div>
              <div className="logout" onClick={logout}>
                <span>Log Out</span>
              </div>
            </div>
          </div>
          <div className="second">
            <div className="left">
              <div className="profile">
                <img src="https://i.gadgets360cdn.com/large/cryptopunk_6046_twitter_1634554177991.jpg"></img>
                <span>@{user.displayName}</span>
              </div>
              <div className="gms">
                <div className="play" onClick={twiit()}>
                  <a href={twiit()} target="blank">
                    <span>Play the GM contest</span>
                  </a>
                </div>
                <div className="stats">
                  <span className="percent">67%</span>
                  <span className="your">Your GM score</span>
                </div>
                <div className="get_score">
                  <span>Get GM score</span>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="twits">
                <span className="socin">Social Identity</span>
                <div className="twitter">
                  <img src={twitter}></img>
                  <span className="s1">@{user.tweetHandle}</span>
                  <span className="s2">Ownership Verified</span>
                </div>
              </div>
              <div className="tkns">
                <span className="townr">Token Ownership</span>
                <div className="comms">
                  <div className="tokens">
                    {isLoading && (
                      <PropagateLoader
                        color={"#4d00ac"}
                        isLoading={isLoading}
                        size={50}
                        css={css}
                        style={style}
                      />
                    )}
                    {!isLoading &&
                      !notok &&
                      comm.map((commi, index) => {
                        return (
                          <div className="g1" key={index}>
                            <img src={commi.logo} alt=""></img>
                            <span>{commi.name}</span>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="NFT">
                <span className="townr">All Tokens</span>
                <div className="comms">
                  <div className="tokens">
                    {isLoading && (
                      <PropagateLoader
                        color={"#4d00ac"}
                        isLoading={isLoading}
                        size={50}
                        css={css}
                        style={style}
                      />
                    )}
                    {!isLoading &&
                      !notok &&
                      nft.map((nfti, index) => {
                        return (
                          <div className="g1" key={index} id={index}>
                            <img
                              src={nfti.media[0].gateway}
                              onError={(event) =>
                                (document.getElementById(index).style.display =
                                  "None")
                              }
                            ></img>
                            <span>{nfti.metadata.name}</span>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Newprof;
